// eslint-disable-next-line import/no-webpack-loader-syntax
module.exports = require('./lib/bootstrap.loader!./no-op.js');



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-loader/loader.js
// module id = 1131
// module chunks = 0